<template>

  <div>
    <b-row class="mb-3">
      <b-col sm="9">
        <b-input-group>
          <input type="text" placeholder="Buscar" class="form-control" v-model="dataPaginate.search" />
          <b-input-group-append>
            <b-button variant="info" class="button-input-group" size="small" @click="searching()">
              <i class="fa fa-search" />
              <span class="d-none d-md-inline-block ml-1" v-text="'Buscar'" />
            </b-button>
            <b-button class="button-input-group" @click="clearFilter()">
              <i class="fa fa-eraser" />
              <span class="d-none d-md-inline-block ml-1" v-text="' Limpiar'" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col sm="3">
        <b-button variant="info" class="float-right" to="/inventories/create-section">
          <i class="fa fa-plus" />
          <span class="d-none d-md-inline-block ml-1" v-text="' Nueva sección'" />
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-table responsive hover :items="sections.data" :fields="columns" thead-tr-class="table-active" class="mb-2">

          <!-- Columna nombre -->
          <template v-slot:cell(name)="data">
            <GuardIsProtected :isProtected="data.item.is_protected" :name="data.item.name" />
          </template>

          <!-- Columna color -->
          <template class="text-center" v-slot:cell(color)="data">
            <div class="data-color" :style="[{ 'background-color': data.item.color }]"></div>
          </template>

          <template v-slot:cell(actions)="data">
            <el-tooltip content="Editar" placement="bottom" effect="light">
              <a class="botonProduct text-dark mr-3" @click="edit(data.item.id)">
                <i class="fa fa-edit"></i>
              </a>
            </el-tooltip>
          </template>
        </b-table>

        <el-pagination v-if="sections.data && !!sections.data.length" v-model="dataPaginate.page"
          @size-change="getSection" @current-change="getSection" :current-page.sync="dataPaginate.page"
          class="float-right" :page-size.sync="dataPaginate.perPage" :page-sizes="[10, 15, 20, 50]"
          layout="total, sizes, prev, pager, next" :total="sections.total" />
      </b-col>
    </b-row>

  </div>
</template>

<script>

// Generales
import { mapState, mapMutations, mapActions } from "vuex";

// Componentes
import Breadcrumb from '../components/Breadcrumb.vue'
import GuardIsProtected from '../components/sections/GuardIsProtected.vue'

// Mixins
import IndexMixin from "../../../servicios/inventory/mixins/sections/index"

export default {

  name: 'InventorySectionsIndex',

  components: {
    Breadcrumb,
    GuardIsProtected
  },

  mixins: [IndexMixin],

  computed: {

    ...mapState('sections', ['columns', 'sections', 'dataPaginate'])

  },

  mounted() {
    this.load(false);
    this.getSection();
  },

  methods: {

    ...mapMutations("dashboard", ["load"]),
    ...mapMutations("sections", ['setSections', 'setDataPaginate', 'resetDataPagination']),

    ...mapActions("sections", ['getSections']),

    async getSection() {
      const res = await this.getSections(this.dataPaginate);
      this.setSections(res);
    },

    async searching() {
      this.dataPaginate.page = 1;
      const res = await this.getSections(this.dataPaginate);
      this.setSections(res);
    },

    edit(id) {
      this.$router.push({
        path: "/inventories/update-section/" + id
      });
    },

    clearFilter() {
      this.resetDataPagination()
      this.getSection();
    }

  }
};
</script>

<style>
.data-color {
  border-radius: 1px;
  width: 50px;
  height: 25px;
}
</style>
